import sizes from "./Sizes";

export default {
  mobileS: `(min-width: ${sizes.mobileS})`,
  mobileM: `(min-width: ${sizes.mobileM})`,
  mobileL: `(min-width: ${sizes.mobileL})`,
  tablet: `(min-width: ${sizes.tablet})`,
  laptop: `(min-width: ${sizes.laptop})`,
  laptopL: `(min-width: ${sizes.laptopL})`,
  desktop: `(min-width: ${sizes.desktop})`,
  desktopL: `(min-width: ${sizes.desktop})`,
  laptopHeightS: `(min-height: ${sizes.laptopHeightS})`,
  mobileHeightShort: `(min-height: ${sizes.mobileHeightShort})`,
  mobileHeightMedium: `(min-height: ${sizes.mobileHeightMedium})`,
  mobileHeightTall: `(min-height: ${sizes.mobileHeightTall})`,
};
